import { render, staticRenderFns } from "./DelSupplier.vue?vue&type=template&id=d064c3b8&scoped=true&"
import script from "./DelSupplier.vue?vue&type=script&lang=js&"
export * from "./DelSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d064c3b8",
  null
  
)

export default component.exports